import axios from "axios";
import ApiConfig from "../config/ApiConfig";
import {
  setLoading,
  setCartData,
  setCartDataError,
  setSuccessAddCartData,
  setAddCartDataError,
  setRemoveCartDataError,
} from "../redux/cart";
import { STATUS_200, STATUS_300 } from "../data/constants";
import { deleteApiPayload, errorMessage } from "../lib/helper";
import { toast } from "react-toastify";
export const GetAllCartData = () => {
  return async (dispatch) => {
    try {
      dispatch(setLoading(true));
      const resp = await axios.get(`${ApiConfig.getAllCartData}`);
      if (resp?.data?.status >= STATUS_200 && resp?.data?.status < STATUS_300) {
        dispatch(setCartData(resp?.data?.data));
        dispatch(setLoading(false));
      } else {
        throw resp;
      }
    } catch (e) {
      dispatch(
        setCartDataError({
          isError: true,
          message: errorMessage(e),
        })
      );
      toast.error(errorMessage(e), {
        autoClose: 2500,
      });
      dispatch(setLoading(false));
    }
  };
};

export const AddImageToCart = (payload) => {
  if (payload !== undefined) {
    return async (dispatch) => {
      try {
        dispatch(setLoading(true));
        const resp = await axios.post(`${ApiConfig.addImageToCart}`, payload);
        if (
          resp?.data?.status >= STATUS_200 &&
          resp?.data?.status < STATUS_300
        ) {
          dispatch(GetAllCartData());
          dispatch(setSuccessAddCartData(true));
          dispatch(setLoading(false));
          toast.success(resp?.data?.message, {
            autoClose: 1500,
          });
        } else {
          throw resp;
        }
      } catch (e) {
        dispatch(
          setAddCartDataError({
            isError: true,
            message: errorMessage(e),
          })
        );
        toast.error(errorMessage(e), {
          autoClose: 2500,
        });
        dispatch(setLoading(false));
      }
    };
  }
};

export const RemoveImageFromCart = (payload) => {
  if (payload !== undefined) {
    return async (dispatch) => {
      try {
        dispatch(setLoading(true));
        const resp = await axios.delete(
          `${ApiConfig.removeImageFromCart}`,
          deleteApiPayload(payload)
        );
        if (
          resp?.data?.status >= STATUS_200 &&
          resp?.data?.status < STATUS_300
        ) {
          dispatch(GetAllCartData());
          dispatch(setLoading(false));
          toast.success(resp?.data?.message, {
            autoClose: 2500,
          });
        } else {
          throw resp;
        }
      } catch (e) {
        dispatch(
          setRemoveCartDataError({
            isError: true,
            message: errorMessage(e),
          })
        );
        toast.error(errorMessage(e), {
          autoClose: 2500,
        });
        dispatch(setLoading(false));
      }
    };
  }
};

export const UpgradeImageVideoToCart = (payload) => {
  if (payload !== undefined) {
    return async (dispatch) => {
      try {
        dispatch(setLoading(true));
        const resp = await axios.post(
          `${ApiConfig.upgradeImageVideoToCart}`,
          payload
        );
        if (
          resp?.data?.status >= STATUS_200 &&
          resp?.data?.status < STATUS_300
        ) {
          dispatch(GetAllCartData());
          dispatch(setSuccessAddCartData(true));
          dispatch(setLoading(false));
          toast.success(resp?.data?.message, {
            autoClose: 2500,
          });
        } else {
          throw resp;
        }
      } catch (e) {
        dispatch(
          setAddCartDataError({
            isError: true,
            message: errorMessage(e),
          })
        );
        toast.error(errorMessage(e), {
          autoClose: 2500,
        });
        dispatch(setLoading(false));
      }
    };
  }
};
